import * as React from 'react';

function SvgInstagram(props) {
  return (
    <svg
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        d="M512 138.598v234.804C512 449.824 449.824 512 373.402 512H138.598C62.176 512 0 449.824 0 373.402V138.598C0 62.176 62.176 0 138.598 0h234.804C449.824 0 512 62.176 512 138.598zm0 0"
        fill="#ff5e95"
      />
      <path
        d="M512 138.598v234.804C512 449.824 449.824 512 373.402 512H256.141V0h117.261C449.824 0 512 62.176 512 138.598zm0 0"
        fill="#ff3980"
      />
      <path
        d="M256 116.004c-77.191 0-139.996 62.805-139.996 139.996S178.809 395.996 256 395.996 395.996 333.191 395.996 256 333.191 116.004 256 116.004zm0 249.976c-60.645 0-109.98-49.335-109.98-109.98S195.355 146.02 256 146.02 365.98 195.355 365.98 256 316.645 365.98 256 365.98zm0 0"
        fill="#fff"
      />
      <g fill="#96fff6">
        <path d="M399.344 66.285c-22.809 0-41.367 18.555-41.367 41.367s18.558 41.371 41.367 41.371c22.812 0 41.37-18.558 41.37-41.37s-18.558-41.368-41.37-41.368zm0 0M395.996 256c0 77.191-62.805 139.996-139.996 139.996V365.98c60.645 0 109.98-49.335 109.98-109.98S316.645 146.02 256 146.02v-30.016c77.191 0 139.996 62.805 139.996 139.996zm0 0" />
      </g>
    </svg>
  );
}

export default SvgInstagram;
